export const mutations = {
  setUser (state, payload) {
    // localStorage.setItem("user", JSON.stringify(payload))
    state.user = payload;
  },
  clearUser (state) {
    // localStorage.removeItem("user")
    state.user = null;
  },
  setAuth (state, payload) {
    state.isAuthenticated = payload;
  },
  clearAuth(state) {
    state.isAuthenticated = false;
  },
  setError (state, payload) {
    state.error = payload;
  },
  clearError(state) {
    state.error = null;
  },
  setLoading (state, payload) {
    state.loading = payload;
  },
  setUsers (state, payload) {
    state.users = payload
  },
  setTransfers (state,payload){
    state.transfers = payload;
  },
  clearTransfers (state){
    state.transfers = null;
  },
  clearUsers (state) {
    state.users = null;
  },
  setPerPage(state, payload) {
    state.perPage = payload
  }
}